import axios from 'axios';

export default axios.create({
    baseURL: 'http://www.rancholasardillas.com/api/'
});